"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.AvatarDropdown = void 0;

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _containers = require("../containers");

var _themeNav = require("./theme-nav");

var _NavAvatar = _interopRequireDefault(require("./NavAvatar"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AvatarDropdown = ( /*#__PURE__*/0, _styledBase.default)(_containers.Dropdown, {
  target: "e1cik2q90",
  label: "AvatarDropdown"
})(_themeNav.dropdownPosition.left, ";", _themeNav.navDropdownStyles, ";&:hover{background:", _themeNav.navItemHoverBgColor, ";i{background:", _themeNav.navAvatarHoverColor, ";}}@media screen and (max-width:1000px){order:", function (props) {
  return props.mobileorder;
}, ";&:hover{background:none;}}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
exports.AvatarDropdown = AvatarDropdown;

var NavLinksUser = function NavLinksUser(_ref) {
  var links = _ref.links,
      avatarUrl = _ref.avatarUrl,
      mobileorder = _ref.mobileorder;

  var trigger = function trigger() {
    return /*#__PURE__*/_react.default.createElement(_NavAvatar.default, {
      size: "small",
      src: avatarUrl
    });
  };

  return /*#__PURE__*/_react.default.createElement(AvatarDropdown, {
    Trigger: trigger,
    links: links,
    mobileorder: mobileorder
  });
};

var dropdownLinkShape = _propTypes.default.shape({
  name: _propTypes.default.string,
  path: _propTypes.default.string
});

NavLinksUser.defaultProps = {
  mobileorder: ''
};
NavLinksUser.propTypes = {
  mobileorder: _propTypes.default.string,
  links: _propTypes.default.arrayOf(_propTypes.default.oneOfType([dropdownLinkShape, _propTypes.default.arrayOf(dropdownLinkShape)])).isRequired,
  avatarUrl: _propTypes.default.string
};
NavLinksUser.defaultProps = {
  avatarUrl: undefined
};
var _default = NavLinksUser;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@contently/toolkit/dist/nav/NavLinksUser.js
// module id = 769
// module chunks = 0 15 16 17 18